import React from 'react'

import CollaboratorsLayout from 'presentation/hospital/layouts/Collaborators'

export default function Collaborators() {
  return <CollaboratorsLayout />
}
